'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failureState = exports.successState = exports.requestState = exports.initialState = exports.fetchStatusFromResources = exports.fetchStatus = exports.shouldRefresh = exports.shouldFetch = undefined;

var _fastMemoize = require('fast-memoize');

var _fastMemoize2 = _interopRequireDefault(_fastMemoize);

var _idx = require('idx');

var _idx2 = _interopRequireDefault(_idx);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var shouldFetch = exports.shouldFetch = function shouldFetch(state) {
  var fetchStatus = (0, _idx2.default)(state, function (_) {
    return _.fetchStatus;
  });

  if (!fetchStatus) {
    return true;
  }

  if (fetchStatus.isError) {
    return false;
  }

  if (fetchStatus.isLoading) {
    return false;
  }

  return !fetchStatus.isLoaded;
};

var shouldRefresh = exports.shouldRefresh = function shouldRefresh(_ref) {
  var fetchStatus = _ref.fetchStatus;
  return fetchStatus.isLoaded && fetchStatus.lastFetch && (new Date().getTime() - fetchStatus.lastFetch) / 1000 > 180;
};

var fetchStatus = exports.fetchStatus = (0, _fastMemoize2.default)(function () {
  for (var _len = arguments.length, resources = Array(_len), _key = 0; _key < _len; _key++) {
    resources[_key] = arguments[_key];
  }

  var isLoading = resources.reduce(function (acc, resource) {
    return acc || resource.fetchStatus.isLoading;
  }, false);
  var isError = resources.reduce(function (acc, resource) {
    return acc || resource.fetchStatus.isError;
  }, false);
  var isLoaded = !isLoading && !isError && resources.reduce(function (acc, resource) {
    return acc && resource.fetchStatus.isLoaded;
  }, true);
  return {
    isLoading: isLoading,
    isLoaded: isLoaded,
    isError: isError
  };
});
var fetchStatusFromResources = exports.fetchStatusFromResources = (0, _fastMemoize2.default)(function () {
  for (var _len2 = arguments.length, resources = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    resources[_key2] = arguments[_key2];
  }

  var isLoading = resources.reduce(function (acc, resource) {
    return acc || (resource.fetchStatus ? resource.fetchStatus.isLoading : false);
  }, false);
  var isError = resources.reduce(function (acc, resource) {
    return acc || (resource.fetchStatus ? resource.fetchStatus.isError : true);
  }, false);
  var isLoaded = !isLoading && !isError && resources.reduce(function (acc, resource) {
    return acc && (resource.fetchStatus ? resource.fetchStatus.isLoaded : false);
  }, true);
  return {
    isLoading: isLoading,
    isLoaded: isLoaded,
    isError: isError
  };
});

var initialState = exports.initialState = function initialState() {
  return {
    isLoading: false,
    isLoaded: false,
    isError: false,
    lastFetch: null
  };
};

var requestState = exports.requestState = function requestState() {
  return {
    isLoading: true,
    isLoaded: false,
    isError: false,
    lastFetch: new Date().getTime()
  };
};

var successState = exports.successState = function successState() {
  return {
    isLoading: false,
    isLoaded: true,
    isError: false,
    lastFetch: new Date().getTime()
  };
};

var failureState = exports.failureState = function failureState() {
  return {
    isLoading: false,
    isLoaded: false,
    isError: true,
    lastFetch: new Date().getTime()
  };
};